// var sleep=(timeout)=>(new Promise((resolve)=>setTimeout(resolve, timeout)));

var detectTouchSwipe = function (el, nextCb, prevCb) {
  var startPoint = null;
  var endPoint = null;
  var treshold = 40;
  $(el)
    .off('touchstart')
    .on('touchstart', function (e) {
      if (e.originalEvent.touches.length == 1) {
        startPoint = [
          e.originalEvent.touches[0].clientX,
          e.originalEvent.touches[0].clientY,
        ];
      }
    });
  $(el)
    .off('touchmove')
    .on('touchmove', function (e) {
      if (e.originalEvent.touches.length == 1) {
        endPoint = [
          e.originalEvent.touches[0].clientX,
          e.originalEvent.touches[0].clientY,
        ];
      }
    });
  $(el)
    .off('touchend')
    .on('touchend', function (e) {
      if (e.originalEvent.touches.length != 0) return;
      if (!startPoint || !endPoint) return;
      var angle =
        Math.abs(endPoint[0] - startPoint[0]) >
        Math.abs(endPoint[1] - startPoint[1]);
      if (endPoint[0] < startPoint[0] - treshold && angle) nextCb && nextCb();
      if (endPoint[0] > startPoint[0] + treshold && angle) prevCb && prevCb();
      startPoint = null;
      endPoint = null;
    });
};

export default function (args) {
  $('.intro-carousel-scale').each(function () {
    var index = 0;
    var items = $(this).find('>ul>li');
    items.each(function () {
      var mode = $(this).attr('data-mode') || '';
      var color = ($(this).attr('data-color') || '').replace('#', '');
      var rgb = [
        parseInt(color.substring(0, 2), 16),
        parseInt(color.substring(2, 4), 16),
        parseInt(color.substring(4, 6), 16),
      ];
      var bg = `linear-gradient(to right, rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 1) 0%, rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0) 100%)`;
      if (mode.indexOf('fsi') != -1) {
        bg = `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, 0.2)`;
        $(this).find('.proj-bg').addClass('fsi');
      } else {
        $(this).find('.proj-bg').removeClass('fsi');
      }
      // var em=$("<em />", {css: {background: bg}});
      // $(this).find(".proj-bg").append(em);
    });
    var prev = $(this).find('.car-nav .prev');
    var next = $(this).find('.car-nav .next');
    var animActive = false;
    var updateIndex = function (newIndex) {
      if (animActive) return;
      animActive = true;
      setTimeout(() => (animActive = false), 600);
      index = newIndex;
      items.removeClass('active prev next');
      items.eq(index).addClass('active');
      if (items.length >= 3) {
        items.eq((index + 1) % items.length).addClass('next');
        items.eq((index + items.length - 1) % items.length).addClass('prev');
      }
      var item = items.eq(index);
      $('.intro.fullsc:not(.intro-drag)')
        .removeClass('lbg dbg fsi')
        .addClass(item.attr('data-mode') || '')
        .css('background', item.attr('data-color'));
    };
    prev.click(function (e) {
      e.preventDefault();
      updateIndex((index + items.length - 1) % items.length);
    });
    next.click(function (e) {
      e.preventDefault();
      updateIndex((index + 1) % items.length);
    });
    updateIndex(0);
    detectTouchSwipe(
      $(this),
      () => next.click(),
      () => prev.click()
    );
  });

  $('.intro-page-bg ul').each(function () {
    var els = $(this).find('>li');
    var update = 0;
    var updateOpacity = function () {
      for (var i = update; i < els.length; i += 4) {
        els.eq(i).css('opacity', Math.random());
      }
      update = (update + 1) % 4;
    };
    setTimeout(
      () => {
        updateOpacity();
        setInterval(updateOpacity, 275);
      },
      args && args.immediate ? 2000 : 9000
    );
  });

  $('.faq-list').each(function () {
    var items = $(this).find('>li');
    var titles = $(this).find('.faq-title');
    var contents = $(this).find('.faq-content');
    titles.css('cursor', 'pointer');
    contents.css('overflow', 'hidden');
    titles.click(function (e) {
      e.preventDefault();
      var index = titles.index(this);
      var item = items.eq(index);
      var itemToClose = null;
      var itemToOpen = null;
      if (item.hasClass('open')) {
        itemToClose = item;
      } else {
        itemToClose = items.filter('.open');
        itemToOpen = item;
      }
      itemToClose &&
        itemToClose.each(function () {
          var content = $(this).find('.faq-content');
          content.css({ height: 0 });
          itemToClose.removeClass('open');
          setTimeout(() => itemToClose.removeClass('partopen'), 300);
          $(this)
            .find('a span span')
            .html($(this).find('a').attr('data-closed'));
        });
      itemToOpen &&
        itemToOpen.each(function () {
          var content = $(this).find('.faq-content');
          itemToOpen.addClass('open');
          itemToOpen.addClass('partopen');
          content.css({ height: 0 });
          setTimeout(
            () => content.css({ height: content[0].scrollHeight }),
            20
          );
          $(this)
            .find('a span span')
            .html($(this).find('a').attr('data-opened'));
        });
    });
  });

  $('.episode-list').each(function () {
    var $this = $(this);
    var $selectCurrent = $this.find('.select .current');
    var $selectOpts = $this.find('.select li');
    var $episodes = $this.find('.faq-list>li');

    const posterEl = $('#season_poster img');
    let oldPoster = posterEl.attr('src');

    $selectOpts
      .click(function (e) {
        $selectCurrent.html($(this).html());
        var seasonId = $(this).attr('data-season-id');
        
        if (seasonId) {
          $("#episodes").show();

          $("#episodes .season-list-" + seasonId).show();
          $("#episodes .faq-list").not(".season-list-" + seasonId).hide();
        } else {
          $("#episodes").hide();
          $("#episodes .faq-list").hide();
        }

        if (posterEl) {
          const seasonPoster = $(this).attr('data-season-img');

          let poster = oldPoster;
          if (seasonPoster) {
            poster = seasonPoster;
          }

          posterEl.attr('src', poster);
        }

        $episodes.each(function () {
          if ($(this).attr('data-season-id') == seasonId) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      })
      .eq(0)
      .click();
  });

  $('.page-list-split, .page-items-list').each(function () {
    var index = 0;
    var items = $(this).find('ul.pli-img-list>li');
    var prev = $(this).find('.pli-nav .prev');
    var next = $(this).find('.pli-nav .next');
    var animActive = false;
    var updateIndex = function (newIndex) {
      if (animActive) return;
      animActive = true;
      setTimeout(() => (animActive = false), 600);
      index = newIndex;
      items.removeClass('active prev next');
      items.eq(index).addClass('active');
      if (items.length >= 3) {
        items.eq((index + 1) % items.length).addClass('next');
        items.eq((index + items.length - 1) % items.length).addClass('prev');
      }
    };
    prev.click(function (e) {
      e.preventDefault();
      updateIndex((index + items.length - 1) % items.length);
    });
    next.click(function (e) {
      e.preventDefault();
      updateIndex((index + 1) % items.length);
    });
    updateIndex(0);
  });

  $('.applybtn').click(function (e) {
    e.preventDefault();
    $('.job-apply').addClass('show');
  });
  $('.job-apply .close').click(function (e) {
    e.preventDefault();
    $('.job-apply').removeClass('show');
  });

  $('.intro .lg-btn').hover(
    function () {
      $(this).closest('.intro').addClass('hover');
    },
    function () {
      $(this).closest('.intro').removeClass('hover');
    }
  );

  $('.list-mode-widget li').click(function (e) {
    e.preventDefault();
    $('.list-mode-widget li').removeClass('active');
    $(this).addClass('active');
    var index = $('.list-mode-widget li').index(this);
    if (index == 0) {
      $('.prod-list-item').show();
      $('.prod-list-item .anim-imgzoom').each(function () {
        $(this).addClass('to-anim');
        setTimeout(() => {
          $(this).addClass('end-anim');
        }, 50 + 100 * index);
        setTimeout(() => {
          $(this).removeClass('to-anim end-anim');
        }, 600 + 100 * index);
      });
      $('.prod-list-item .anim-words').each(function (index) {
        $(this).addClass('to-anim');
        setTimeout(() => {
          $(this).addClass('end-anim');
        }, 50 + 100 * index);
        setTimeout(() => {
          $(this).removeClass('to-anim end-anim');
        }, 600 + 100 * index);
      });
      $('.dynamic-sec.lbg').hide();
    } else {
      $('.prod-list-item').hide();
      $('.dynamic-sec.lbg').show();
      $('.dynamic-sec.lbg .anim-imgzoom').each(function (index) {
        $(this).addClass('to-anim');
        setTimeout(() => {
          $(this).addClass('end-anim');
        }, 50 + 100 * index);
        setTimeout(() => {
          $(this).removeClass('to-anim end-anim');
        }, 600 + 100 * index);
      });
      $('.dynamic-sec.lbg .anim-words').each(function (index) {
        $(this).addClass('to-anim');
        setTimeout(() => {
          $(this).addClass('end-anim');
        }, 50 + 100 * index);
        setTimeout(() => {
          $(this).removeClass('to-anim end-anim');
        }, 600 + 100 * index);
      });
    }
  });

  $('.itemvideo').each(function () {
    var video = this;
    this.loop = true;
    var container = $(this).parent().parent().parent();
    container.click(function (e) {
      e.preventDefault();
      if (video.paused) {
        container.addClass('playing');
        video.play();
      } else {
        container.removeClass('playing');
        video.pause();
      }
    });
  });
}
